<template>
  <sdPageHeader :title="$t('pages.tickets.detail.title')"> </sdPageHeader>
  <Main>
    <center><a-spin v-if="isLoading" /></center>
    <a-list class="comment-list" item-layout="horizontal" :data-source="singleContent">
      <template #renderItem="{ item }">
        <a-list-item>
          <a-card style="width: 100%">
            <a-comment>
              <template #author>
                <a-tag :color="item.identity == 'staff' ? 'pink' : 'green'">{{ item.author }}</a-tag>
              </template>
              <template #avatar>
                <img :src="item.avatar" style="height: 45px; width: 45px" />
              </template>
              <template #content>
                <span v-html="item.content"> </span>
              </template>
              <template #datetime>
                <span>{{ item.datetime }}</span>
              </template>
            </a-comment>
          </a-card>
        </a-list-item>
      </template>
    </a-list>
    <br />
    <sdCards>
      <a-form :model="form" layout="vertical" @submit="sendMessage">
        <a-form-item>
          <ckeditor :editor="editor" v-model="form.comment" :config="editorConfig"></ckeditor>
        </a-form-item>

        <a-form-item>
          <a-button id="textbox" :loading="iconLoading" type="primary" html-type="submit">
            {{ $t('pages.apps.general.button-save') }}
          </a-button>
        </a-form-item>
      </a-form>
    </sdCards>
  </Main>
</template>
<script>
import { Main } from '@/view/styled';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { dateToTr } from '@/utility/helper.js';

export default {
  name: 'ChatApp',
  components: {
    Main,
  },
  data() {
    return {
      username: this.$store.state.auth.user_name + ' ' + this.$store.state.auth.user_surname,
      editor: ClassicEditor,
      editorConfig: {},
      isLoading: true,
      id: this.$route.params.id,
      title: '',
      form: {
        comment: '',
      },
      singleContent: [],
      iconLoading: false,
    };
  },
  methods: {
    get() {
      this.$appAxios
        .post(this.$endpoints.ticket_detail, { id: this.id })
        .then((response) => {
          if (response.data.status === true) {
            var tableData = response.data.data.chat;
            this.title = response.data.data.title;
            this.singleContent = [];
            var _this = this;
            tableData.forEach(function (item, index) {
              _this.singleContent.push({
                datetime: dateToTr(item.time),
                identity: item.identity,
                content: item.content,
                author: item.name || _this.username,
                avatar: require('@/static/img/ticket/' + item.identity + '.png'),
              });
            });
            setTimeout(() => {
              document.getElementById('textbox').focus({ preventScroll: false });
            }, 1000);
          } else {
            this.$message.error(resp.data.message);
          }
          this.isLoading = false;
        })
        .catch((e) => {
          console.log(e);
          this.isLoading = false;
          this.$message.error(this.$t('common.error-message'));
        });
    },
    sendMessage() {
      this.iconLoading = true;
      const hide = this.$message.loading(this.$t('common.progress-message'), 0);

      this.form.id = this.id;
      var message = {
        content: this.form.comment,
        identity: 'user',
        author: this.username,
        datetime: null,
        avatar: require('@/static/img/ticket/user.png'),
      };

      this.$appAxios
        .post(this.$endpoints.ticket_add, this.form)
        .then((response) => {
          if (response.data.status === true) {
            this.$message.success(this.$t('common.success-message'));
            this.form.comment = '';
            this.singleContent.push(message);
          } else {
            this.$message.error(this.$t('common.error-message'));
          }
          hide();
          this.iconLoading = false;
        })
        .catch((e) => {
          this.$message.error(this.$t('common.error-message'));
          this.iconLoading = false;
          hide();
        });
    },
  },
  created() {
    this.get();
  },
};
</script>

<style scoped>
.ps {
  height: 495px;
}
</style>
